// extracted by mini-css-extract-plugin
export default {"container":"NCriAB","grid":"hSa93u","item":"YueD6W","bg":"FwXirT"};